import { Component } from 'react';
import {  Message } from 'semantic-ui-react';
// import './NotificationLetter.css'
import Step1DetailIneligible from './Step1DetailIneligible';
import Step1DetailApproval from './Step1DetailApproval';
import Step1DetailRejection from './Step1DetailRejection';

class Step1NotificationLetter extends Component {
    
    getEligibilityDecision = () => {
        const project = this.props.projectState.project;
        //console.log(project);
        if (project.firstStepDecision !== null) {
            if (project.firstStepDecision.finalFundingDecision !== null) {
                if (project.firstStepDecision.finalFundingDecision.status === 'STEP1_APPROVED_WITH_CONDITIONS' || project.firstStepDecision.finalFundingDecision.status === 'STEP1_APPROVED') {
                    return <Step1DetailApproval />
                } else {
                    return <Step1DetailRejection/>
                }
            }
            if (project.firstStepDecision.eligibilityDecision !== null) {
                if (project.firstStepDecision.eligibilityDecision.status === 'STEP1_ELIGIBLE') {
                    return this.displayError(null, 'Project is Eligible but there is no Step1 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step1 decision is available');
                } else {
                    return (
                        <Step1DetailIneligible />
                    )
                }
            } else {
                return this.displayError(null, 'There is no Step1 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step1 decision is available');
            }
        } else {
            return this.displayError(null, 'There is no Step1 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step1 decision is available');
        }
    }

    displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    render() {
        return (
            <div>
                {this.getEligibilityDecision()}
            </div>
        )
    }
}

export default Step1NotificationLetter;
